import { Helper } from "./helper.js";

export class CashExpensesHelper {
    public static getSum(quantity: number, value: number) {
        let sum = 0;
        if (Helper.hasValue(quantity) && Helper.hasValue(value)) {
            sum = quantity * value;
            sum = parseFloat(sum.toFixed(2))
        }
        return sum;
    }

    public static getSumInCurrency(sum: number, factor: number) {
        let sumInCurrency = sum;
        if (Helper.hasValue(factor) && factor > 0) {
            sumInCurrency = sum / factor;
            sumInCurrency = parseFloat(sumInCurrency.toFixed(2))
        }
        return sumInCurrency;
    }

    public static getExpenses(quantity: number, value: number, costFactor: number, expensesAmount: number) {
        let expenses = quantity * value;
        if (Helper.hasValue(costFactor) && costFactor != 0) {
            expenses = expenses * costFactor;
        } else if (Helper.hasValue(expensesAmount)) {
            expenses = quantity * expensesAmount;
        }
        return expenses;
    }

    public static getInvoice(quantity: number, value: number, invoiceFactor: number, invoiceAmount: number) {
        let invoice = quantity * value;
        if (Helper.hasValue(invoiceFactor) && invoiceFactor != 0) {
            invoice = invoice * invoiceFactor;
        } else if (Helper.hasValue(invoiceAmount)) {
            invoice = quantity * invoiceAmount
        }
        return invoice;
    }
}